import { createRESTContract } from '../../index';
import { NotificationPendingCountsResponseSchema } from './notifications.schema';

export const notificationsContract = createRESTContract({
  getPendingCounts: {
    method: 'GET',
    path: '/notifications/pending-counts',
    // * Empty permissions array means any authenticated user can call this endpoint.
    // * The service filters each count based on what the caller is actually permitted to see.
    permissions: [],
    response: NotificationPendingCountsResponseSchema,
  },
});
